// Автоссылки в тексте ответа (план 26.08.2026, ступень 1): адрес страницы в
// реплике бота становится ссылкой. Чистый модуль без DOM — виджет собирает
// узлы руками (innerHTML не трогает), а разбор текста тестируется в изоляции
// (linkify.test.mjs).
export type TextPart = { text: string; url?: string };

/** Только со схемой: голое «ассиистент.рф/help» ссылкой не делаем — слишком
 *  легко принять за адрес «руб./шт.» или имя файла. Кириллические домены
 *  проходят: класс исключает лишь пробелы и кавычки. */
const URL_RE = /https?:\/\/[^\s<>"'«»]+/gu;
/** Хвостовая пунктуация фразы («…смотрите https://site.ru/pricing.») — не
 *  часть адреса; возвращается в текст. */
const TRAILING_RE = /[.,;:!?»")\]]+$/u;
/** После схемы должен идти хотя бы один символ хоста. */
const HAS_HOST_RE = /^https?:\/\/\S/u;

/** Разбить текст на части: обычный текст и адреса (с url). Пустой текст — пусто. */
export function linkify(text: string): TextPart[] {
  const parts: TextPart[] = [];
  let last = 0;
  for (const match of text.matchAll(URL_RE)) {
    const start = match.index ?? 0;
    const trailing = TRAILING_RE.exec(match[0])?.[0] ?? '';
    const url = match[0].slice(0, match[0].length - trailing.length);
    if (!HAS_HOST_RE.test(url)) continue;

    if (start > last) parts.push({ text: text.slice(last, start) });
    parts.push({ text: url, url });
    last = start + url.length;
  }
  if (last < text.length) parts.push({ text: text.slice(last) });
  return parts;
}
